import { useLang } from '@/i18n';
import EfCardsA from '@elem/ui/ef-cards-a';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.ListA');
    const items = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725086902987/LiFePO4%E3%82%BB%E3%83%AB.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725086903326/LiFePO4%E3%82%BB%E3%83%AB%20(1).jpg',
            title: t('a_title'),
            desc: t('a_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1722951969190/Frame%201000008619.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1722952321315/Frame%201000008619%20(1).png',
            title: t('b_title'),
            desc: t('b_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725086903513/%E9%98%B2%E6%B0%B4%E6%80%A7.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725086903148/%E9%98%B2%E6%B0%B4%E6%80%A7%20(1).jpg',
            title: t.rich('c_title', {
                sup: (tx: string) => <sup>{tx}</sup>,
            }),
            desc: t.rich('c_desc', {
                sup: (tx: string) => <sup>{tx}</sup>,
            }),
        },
    ];

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <EfSection hasAnimation={false} label={t('label')} title={t('title')} />
            <EfCardsA list={items} />
        </div>
    );
}
